import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../constants';

import { SubNav } from './SubNav';
import UserInfo from '../containers/UserInfo';

export default ({
  sub,
  subId,
  userId,
  contracts,
  isPortMessageArray,
  upcomingPlan,
}) => (
  <div className="Sub">
    <div className="flex-justify-space-between">
      <h1>Sprint Subscription details</h1>
      <div>
        {!isPortMessageArray ? null : (
          <div>
            <Link to={`/subscriptions/${sub.id}/confirm-switch-to-att`}>
              Confirm switch to AT&T
            </Link>
          </div>
        )}
        <Link
          to={`/users/${userId}/purchases?subscription=${subId}&subCarrier=sprint`}
        >
          Subscription purchases
        </Link>
      </div>
    </div>
    <SubNav sub={sub} />
    <table className="table">
      <tbody>
        <tr>
          <td>ID</td>
          <td>{sub.id}</td>
          <td></td>
        </tr>
        <tr>
          <td>User Profile ID</td>
          <td>{sub.user_profile}</td>
          <td></td>
        </tr>
        <tr>
          <td>First Name</td>
          <td>{sub.first_name}</td>
          <td></td>
        </tr>
        <tr>
          <td>Last Name</td>
          <td>{sub.last_name}</td>
          <td></td>
        </tr>
        <tr>
          <td>MDN</td>
          <td>{sub.mdn}</td>
          <td></td>
        </tr>
        <tr>
          <td>Device ID</td>
          <td>{sub.device_id}</td>
          <td></td>
        </tr>
        <tr>
          <td>ICC ID</td>
          <td>{sub.icc_id}</td>
          <td></td>
        </tr>
        <tr>
          <td>Platform</td>
          <td>{sub.platform}</td>
          <td></td>
        </tr>
        <tr>
          <td>Model</td>
          <td>{sub.model}</td>
          <td></td>
        </tr>
        <tr>
          <td>Sprint Status</td>
          <td>{sub.sprint_status}</td>
          <td></td>
        </tr>
        <tr>
          <td>Effective Date</td>
          <td>
            {sub.effective_date
              ? moment(sub.effective_date).format(DATE_TIME_FORMAT)
              : sub.effective_date}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Expiry Date</td>
          <td>
            {sub.expiry_date
              ? moment(sub.expiry_date).format(DATE_TIME_FORMAT)
              : sub.expiry_date}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Expiry Type</td>
          <td>{sub.expiry_type}</td>
          <td></td>
        </tr>
        <tr>
          <td>Is Primary</td>
          <td>{sub.is_primary && String(sub.is_primary)}</td>
          <td></td>
        </tr>
        <tr>
          <td>PIN</td>
          <td>{sub.pin}</td>
          <td></td>
        </tr>
        <tr>
          <td>Activation Type</td>
          <td>{sub.activation_type}</td>
          <td></td>
        </tr>
        <tr>
          <td>Suspension Type</td>
          <td>{sub.suspension_type}</td>
          <td></td>
        </tr>
        <tr>
          <td>Plan</td>
          <td>
            {sub.plan && (
              <span>
                {sub.plan.name}
                {' - '}${sub.plan.price}
                {' | '}
                Data available: {sub.plan.data_available}MB
                {' | '}
                Voice SMS: {sub.plan.voice_sms && sub.plan.voice_sms.toString()}
              </span>
            )}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Upcoming plan</td>
          <td>
            {upcomingPlan && (
              <span>
                {upcomingPlan.name}
                {' - '}${upcomingPlan.price}
                {' | '}
                Data available: {upcomingPlan.data_available}MB
                {' | '}
                Voice SMS:{' '}
                {upcomingPlan.voice_sms && upcomingPlan.voice_sms.toString()}
              </span>
            )}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Intl Charge Threshold</td>
          <td>${sub.intl_charge_threshold}</td>
          <td></td>
        </tr>
        <tr>
          <td>Over Limit</td>
          <td>{sub.over_limit && sub.over_limit.toString()}</td>
          <td></td>
        </tr>
        <tr>
          <td>Autopay Enabled</td>
          <td>{sub.autopay_enabled && sub.autopay_enabled.toString()}</td>
          <td></td>
        </tr>
        <tr>
          <td>Device Protection Enabled</td>
          <td>{sub.insurance_enabled && sub.insurance_enabled.toString()}</td>
          <td></td>
        </tr>
        <tr>
          <td>SMS Notifications</td>
          <td>{sub.sms_notifications && String(sub.sms_notifications)}</td>
          <td></td>
        </tr>
        <tr>
          <td>Agent ID</td>
          <td>{sub.agent_id}</td>
          <td></td>
        </tr>
        <tr>
          <td>Agent Name</td>
          <td>{sub.agent_name}</td>
          <td></td>
        </tr>
        <tr>
          <td>Device Status</td>
          <td>{sub.device_status}</td>
          <td></td>
        </tr>
        <tr>
          <td>MSL Code</td>
          <td>{sub.msl_code}</td>
          <td></td>
        </tr>
        <tr>
          <td>MSID</td>
          <td>{sub.msid}</td>
          <td></td>
        </tr>
        <tr>
          <td>IMSI</td>
          <td>{sub.imsi}</td>
          <td></td>
        </tr>
        <tr>
          <td>CSA</td>
          <td>{sub.csa}</td>
          <td></td>
        </tr>
        <tr>
          <td>MDN Status</td>
          <td>{sub.mdn_status}</td>
          <td></td>
        </tr>
        <tr>
          <td>Old Carrier</td>
          <td>{sub.old_carrier}</td>
          <td></td>
        </tr>
        <tr>
          <td>New Carrier</td>
          <td>{sub.new_carrier}</td>
          <td></td>
        </tr>
        <tr>
          <td>Deleted</td>
          <td>{String(sub.deleted)}</td>
          <td></td>
        </tr>
        <tr>
          <td>Plan Sprint Code</td>
          <td>{sub.plan_sprint_code}</td>
          <td></td>
        </tr>
        <tr>
          <td>Device Protection Contracts</td>
          <td>
            {contracts &&
              contracts.map((contract) => {
                return (
                  <Link
                    className="mar-r"
                    key={contract.id}
                    to={`/device-protection/contracts/${contract.id}/view`}
                  >
                    ID: {contract.id}
                  </Link>
                );
              })}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Created By</td>
          <td>
            <UserInfo userId={sub.created_by} type="nameIdRole" />
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Plan Locked</td>
          <td>{sub.plan_locked ? 'Locked' : 'Unlocked'}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
);
